import React from "react";
import { Search, Megaphone, Sparkles, ArrowRight } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { content } from "../data/content";
import SectionHeading from "./SectionHeading";

const icons = [Search, Megaphone, Sparkles];

const AdditionalServicesSection = () => {
  const { lang } = useLanguage();
  const t = content[lang].additional;

  return (
    <section id="servicios" className="relative py-24 md:py-28 bg-narwhal-panel/40 border-y border-white/5 scroll-mt-16">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <SectionHeading kicker={t.kicker} title={t.title} accent={t.titleAccent} />

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {t.items.map((item, i) => {
            const Icon = icons[i % icons.length];
            return (
              <div key={item.title} className="group relative rounded-xl border border-white/8 bg-narwhal-dark/40 p-6 hover:border-narwhal-teal/35 transition-colors duration-300">
                {item.badge && (
                  <span className="absolute top-4 right-4 rounded-full border border-narwhal-teal/40 bg-narwhal-teal/10 px-2.5 py-1 text-[10px] font-medium text-narwhal-teal">{item.badge}</span>
                )}
                <div className="flex items-center justify-center w-11 h-11 rounded-lg bg-narwhal-teal/10 text-narwhal-teal group-hover:bg-narwhal-teal group-hover:text-narwhal-dark transition-colors">
                  <Icon className="w-5 h-5" />
                </div>
                <h3 className="mt-5 text-lg font-medium text-white pr-4">{item.title}</h3>
                <p className="mt-2 text-sm text-narwhal-muted leading-relaxed">{item.text}</p>
              </div>
            );
          })}
        </div>
        <button className="mt-8 inline-flex items-center gap-2 rounded-md bg-narwhal-teal/15 px-5 py-2.5 text-sm text-narwhal-teal hover:bg-narwhal-teal hover:text-narwhal-dark transition-colors">
          {t.cta}<ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </section>
  );
};

export default AdditionalServicesSection;
